module.exports = __webpack_public_path__ + "videos/video-d.9ab30c2.mp4";